import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./TreatmentPlanList.css";
import { apiUrl, PORT } from "../../environment";
import Button from "react-bootstrap/Button";
import { getPatientDocumetsList } from "../services/patientService";
import { toast } from "react-toastify";
import { Modal, Row, Col } from "react-bootstrap";
import Loader from "../../utils/Loader";

export default function DocumentsList({ patient }) {
  const [patientDocumentation, setPatientDocumentation] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  const [imagesView, setImagesView] = useState(false);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  /* Function's */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchPatientDocumentList(selectedValue);
  }, [page, limit]);

  const fetchPatientDocumentList = async (eventKey) => {
    try {
      setLoading(true);
      const response = await getPatientDocumetsList({
        patientId: patient,
        page: page + 1,
        limit,
        searchKey: searchText,
        sortBy: eventKey,
      });
      if (response?.status === "SUCCESS") {
        setPatientDocumentation(response?.data);
        setTotalPages(response?.data?.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);

      toast.error("Please try again later");
    }
  };

  // Determine grid layout based on image count
  const getGridClass = () => {
    if (images.length === 1) return "grid-cols-1";
    if (images.length === 2) return "grid-cols-2";
    return "grid-cols-3"; // 3 or more images
  };

  const onClose = () => {
    setImagesView(false);
  };

  const handleViewImages = (images) => {
    setImagesView(true);
    setImages(images);
  };

  const handleSelect = (eventKey) => {
    setSelectedValue(eventKey);
    fetchPatientDocumentList(eventKey);
  };
  return (
    <>
      {loading && <Loader />}

      <div className="Dashboard-lft-blk">
        <div className="lft-blk-top d-flex justify-content-between mb-3">
          <h2>&nbsp;</h2>
          <div className="dropdowns-here d-flex gap-2">
            <Dropdown className="patient-info-dropdown" onSelect={handleSelect}>
              <Dropdown.Toggle className="db-dropdown">
                {selectedValue === ""
                  ? "Sort By"
                  : selectedValue === "recent"
                  ? "recent"
                  : "oldest"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="recent">Recent</Dropdown.Item>
                <Dropdown.Item eventKey="oldest">Oldest</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {/* table for tratment lis  */}
        <div className="table-responsive dashboard-table">
          <table className="patients-table">
            <thead>
              <tr className="t-row-block">
                <th scope="col">Sr No</th>
                <th scope="col">Type of Record</th>
                <th scope="col">Record For</th>
                <th scope="col">Date</th>
                <th scope="col">Tags</th>
                <th scope="col">Files</th>
              </tr>
            </thead>
            <tbody>
              {patientDocumentation.length > 0 ? (
                patientDocumentation?.map((document, index) => (
                  <tr key={document.id || index}>
                    <td scope="row" style={{ borderLeft: "0px" }}>
                      {++index}
                    </td>
                    <td>{document?.typeofRecord}</td>
                    <td>{document?.recordFor}</td>

                    <td style={{ borderRight: "0px" }}>
                      {new Date(document?.recordDate).toLocaleString("en-US", {
                        hour12: true,
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                      })}
                    </td>

                    <td style={{ width: "250px", borderRight: "0px" }}>
                      {Array.isArray(document?.tags) ? (
                        <span className="document-tag-list">
                          {document.tags.map((tag, tagIndex) => (
                            <span key={tagIndex}>{tag}</span>
                          ))}
                        </span>
                      ) : (
                        document?.tags
                      )}
                    </td>
                    <td style={{ width: "150px", borderRight: "0px" }}>
                      <Button
                        onClick={() => handleViewImages(document.files)}
                        className="btn filled-btn"
                      >
                        {" "}
                        View files{" "}
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Documentation Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Modal
          show={imagesView}
          onHide={onClose}
          centered
          className="image-grid-modal"
          dialogClassName="custom-modal-lg"
          style={{ borderRadius: "20px", width: "100%" }}
        >
          <Modal.Header closeButton className="header">
            <Modal.Title>View Images</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className="g-3">
              {images?.map((img, index) => (
                <Col key={index} className={getGridClass()}>
                  <a
                    href={`${apiUrl}${PORT}/patient-service/get-files/image/${img}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      //    src={`img`}
                      src={`${apiUrl}${PORT}/patient-service/get-files/image/${img}`}
                      alt={`Image ${index + 1}`}
                      className="img-fluid rounded shadow-sm"
                    />
                  </a>
                </Col>
              ))}
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="btn btn-primary filled-btn" onClick={onClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
